module.exports = __webpack_public_path__ + "img/placeholder.e796e155.jpg";